import { NavLink } from 'react-router';

import { displayCssClass, effectiveBaseCssClass } from './ngButtonBase';
import type { NgButtonBaseProps } from './ngButtonBase';

export type NgButtonNavLinkProps = NgButtonBaseProps & {
  to?: string;
  href?: string;
  match?: 'all' | 'prefix';
  activeClass?: string;
  disabled?: boolean;
  target?: string;
  download?: boolean;
  downloadFile?: string;
};

export function NgButtonNavLink(props: NgButtonNavLinkProps) {
  const { to, href, match, activeClass, disabled, target, download, downloadFile, icon, text, children } =
    props;

  const effectiveDisabled = disabled ?? (to == null && href == null);
  const disabledCss = effectiveDisabled ? 'disabled' : '';
  const baseCssClass = `${displayCssClass(props)} ${effectiveBaseCssClass(props)} ${disabledCss}`;

  const downloadAttribute =
    downloadFile != null && downloadFile.trim() !== '' ? downloadFile : download ? true : undefined;

  const content = (
    <>
      {icon != null && <i className={icon}></i>}
      {children != null ? children : text}
    </>
  );

  if (href != null) {
    return (
      <a
        className={baseCssClass}
        href={href}
        target={target}
        rel={target === '_blank' ? 'noreferrer' : undefined}
        download={downloadAttribute}
      >
        {content}
      </a>
    );
  }

  if (to == null) {
    return (
      <a className={baseCssClass} target={target} download={downloadAttribute}>
        {content}
      </a>
    );
  }

  const effectiveMatchAll = to === '/' && match == null ? true : (match ?? 'prefix') === 'all';

  return (
    <NavLink
      to={to}
      end={effectiveMatchAll}
      className={({ isActive }) =>
        isActive ? `${baseCssClass} ${activeClass ?? 'active'}` : baseCssClass
      }
      target={target}
      download={downloadAttribute}
    >
      {content}
    </NavLink>
  );
}
